import * as React from "react"
import { Progress as ProgressPrimitive } from "radix-ui"

import { cn } from "@/utils"

const variants = {
  primary: "bg-gray-500",
  success: "bg-green-500",
  danger: "bg-red-500",
}
const bgVariants = {
  primary: "bg-gray-500/20",
  success: "bg-green-500/20",
  danger: "bg-red-500/20",
}

function Progress({
  className,
  value,
  variant="primary",
  ...props
}: React.ComponentProps<typeof ProgressPrimitive.Root> & {variant?: keyof typeof variants}) {
  return (
    <ProgressPrimitive.Root
      data-slot="progress"
      className={cn(
        "relative h-2 w-full overflow-hidden rounded-full ",
        bgVariants[variant],
        className
      )}
      {...props}
    >
      <ProgressPrimitive.Indicator
        data-slot="progress-indicator"
        className={`${variants[variant]} h-full w-full flex-1 transition-all`}
        style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
      />
    </ProgressPrimitive.Root>
  )
}

export { Progress }
